'use strict';

var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var ReactDOM = require('react-dom');
var theme_ThemeProvider = require('../../theme/ThemeProvider.js');
require('../../_chunks/combineClasses-5P8GTQkg.js');
require('../../_chunks/index-CIVOGJRG.js');
require('../../_chunks/designTokens-CKP-YoT2.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var ReactDOM__default = /*#__PURE__*/_interopDefault(ReactDOM);

/** Adds hidden origin element to mark where the Portal was initialized */
const PortalOrigin = react.forwardRef((_, ref) => (jsxRuntime.jsx("span", { ref: ref, "data-portal-origin": true, style: { display: 'none' } })));
PortalOrigin.displayName = 'PortalOrigin';
const Portal = ({ children }) => {
    const [originNode, setOriginNode] = react.useState(null);
    const containerNode = react.useMemo(() => 
    // Because `<dialog>` is rendered at the DOM top-layer, it will be above content rendered in `document.body`
    // Therefore, if a dialog exists as a parent of the portal, we should render the portal using this as container node.
    originNode?.closest('dialog') ?? document.body, [originNode]);
    // We use a deferred value for the container node to avoid unnecessarily re-rendering the portal too often during quick changes.
    // The container node can be reattached quickly multiple times e.g if the Portal is inside a <Suspense> and a lazy loaded component
    // is present somewhere in the Portal's child tree
    const deferredContainerNode = react.useDeferredValue(containerNode);
    return (jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [jsxRuntime.jsx(PortalOrigin, { ref: setOriginNode }), ReactDOM__default.default.createPortal(
            // the children need to be wrapped in a ThemeProvider as they might be rendered outside of the root theme provider
            // node and so would not have access to the css variables defined in the theme
            children ? jsxRuntime.jsx(theme_ThemeProvider.ThemeProvider, { children: children }) : null, deferredContainerNode)] }));
};

exports.Portal = Portal;
//# sourceMappingURL=Portal.js.map
